import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import draftApi from '../../../api/draft.api';
import { lookupI18n } from '../../../shared/utils/objectUtils';
import {
  populateUISchemaWithRulesResults,
  processWorkflowValidations,
} from '../../../shared/configuration/businessRules.helper';

export const getValidationsThunk = createFOAsyncThunk('validations/validate', async (arg, { rejectWithValue }) => {
  const {
    submission,
    uiSchema,
    dialogId,
    dialogBusinessRulesPrefix,
    validationErrors,
    overrideProcedure,
    controller,
  } = arg;
  try {
    const { sectionValidations, uiSchema: validatedUiSchema } = await draftApi.validateBusinessRules(
      submission,
      {
        popupId: dialogId,
        businessRulesPrefix: dialogBusinessRulesPrefix,
        overrideProcedure,
      },
      { signal: controller?.signal },
    );

    const workflowValidations = processWorkflowValidations(sectionValidations);
    const translatedUiSchema = lookupI18n(validatedUiSchema);
    const newUiSchema = populateUISchemaWithRulesResults(uiSchema, translatedUiSchema);

    return {
      submission,
      uiSchema: newUiSchema,
      workflowValidations,
      validationErrors,
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});
